import { Component } from '@angular/core';
import { AuthService } from '../../core/auth-service.component';
import { Router,ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank.component.html',
  styleUrls: []
})

export class BlankComponent {
  private redirectURL: string;
  constructor(private _authService: AuthService,
        private _router: Router,private _route: ActivatedRoute) {}

    ngOnInit() {
      this.redirectURL = this._route.snapshot.queryParams['returnUrl'] || '/applications';
      this._authService.isLoggedIn().then(isLogIn =>{
        if(isLogIn){
          this._router.navigate([this.redirectURL]);
        }else{
          this._authService.login(this.redirectURL);
        }
    })
  }
}

